import { db, functions } from '@/firebase'

export default {
    getZCierres({ commit, rootState }) {
        const negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio)
            .collection('cierrestpv')
            .orderBy('inicio', 'desc')
            .limit(100)
            .get()
            .then((r) => {
                console.log(r.docs.map(c => {
                    return {
                        id: c.id,
                        ...c.data()
                    }
                }))
                commit('setZCierres', r.docs.map(c => {
                    return {
                        id: c.id,
                        ...c.data()
                    }
                }));
            })
            .catch(e => console.log(e))
    }
}